import { isEmpty } from 'underscore';
import AssetPickerAddFolderCollabsOption from './asset-picker-add-folder-collabs-option';
import AssetPickerCopyFolderOption from './asset-picker-copy-folder-option';
import AssetPickerDeleteFolderOption from './asset-picker-delete-folder-option';
import AssetPickerRenameFolderOption from './asset-picker-rename-folder-option';

function AssetPickerEditFolderOptions(props) {
  const currentUser = window.getCurrentUser();
  const { folder, updateCallback } = props;

  const containsGo1Course = folder?.topLevelContents.some((content) => !isEmpty(content.go1Course));

  return (
    <div className="asset-picker-edit-options asset-picker-edit-folder-options">
      <AssetPickerAddFolderCollabsOption folder={folder} />
      <AssetPickerRenameFolderOption folder={folder} updateCallback={updateCallback} />
      {(currentUser.admin || folder?.itemFolderId) && !containsGo1Course ? (
        <AssetPickerCopyFolderOption folder={folder} updateCallback={updateCallback} />
      ) : null}
      {!!currentUser.admin && <AssetPickerDeleteFolderOption folder={folder} updateCallback={updateCallback} />}
    </div>
  );
}

export default AssetPickerEditFolderOptions;
